import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel from "@/__main__/data-model.mjs";

export const model = {
  optedIn: Boolean,
  userId: String,
} satisfies ModelDefinition;

export type UserMarketingEmailOptIn = FromModel<typeof model>;

const UserMarketingEmailOptInModel = createModel({
  data: { findUserOptIn: model },
}).transform(model, (data) => data.data.findUserOptIn);

export default UserMarketingEmailOptInModel;
